module.exports = __webpack_public_path__ + "static/media/599.702(10).6c325116.pdf";